module.exports = {
    excludesHeader: [
        '/take-mock-exam',
        '/resume-mock-exam'
    ]
};